export default __webpack_public_path__ + "static/media/pilz-03.519307e3.png";